import dynamic from "next/dynamic";

const LazyTag = dynamic(() => import("../../components/Tag"));
export default LazyTag;
